export default "__VITE_ASSET__DfSGE1va__"